module.exports = __webpack_public_path__ + "static/img/application_scenarios.b821e205.png";